import React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';

import baseActivityPickerTheme from './ActivityPicker.scss';

const questions = [
    {
        question: 'Ik vind dit:',
        answers: ['Leuk', 'Niet leuk'],
    },
    {
        question: 'Ik doe dit:',
        answers: ['Voor mezelf', 'Voor mama/papa', 'Voor school'],
    },
    {
        question: 'Wanneer:',
        answers: ['Tijdens de week', 'Het weekend'],
    },
];

class ActivityPicker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props,
            activity: '',
            answers: {},
        };
    }

    componentWillMount() {
        this.setInitialAnswer();
    }

    componentWillUnmount() {
        const {
            answers,
            activity,
            newActivity,
            part,
            section,
            setAnswer,
        } = this.state;

        if (this.validState()) {
            setAnswer({
                part,
                section,
                answer: {
                    activity: activity || newActivity,
                    answers,
                },
            });
        }
    }

    setInitialAnswer = () => {
        const { answer, onStateChange } = this.props;

        if (Object.keys(this.state.answers).length === 0 && answer) {
            this.setState({
                activity: answer.activity,
                answers: answer.answers,
            });
            onStateChange(true);
        }
    };

    validState = () => {
        const { answers, activity } = this.state;

        if (activity.length < 3) {
            return false;
        }

        if (Object.keys(answers).length < 3) {
            return false;
        }

        return true;
    };

    enableDisableButton = (activity) => {
        const { part, answers } = this.props;

        if (answers && answers[part]) {
            return Object.keys(answers[part]).find((section) => {
                if (answers[part][section]) {
                    return answers[part][section].activity === activity;
                }
                return false;
            });
        }
        return false;
    };

    handleQuestionAnswer = (q, a) => {
        const { answers, onStateChange } = this.state;

        answers[q] = a;

        this.setState({
            answers,
        });

        onStateChange(this.validState());
    };

    handleChange = (evt) => {
        const { onStateChange } = this.props;

        this.setState({
            activity: evt.target.value,
        });

        onStateChange(this.validState());
    };

    render() {
        const { activity, answers } = this.state;
        const { theme } = this.props;

        const answerColors = {
            'Voor mezelf': theme.me,
            'Voor mama/papa': theme.parents,
            'Voor school': theme.school,
        };

        return (
            <div>
                <p className="question-subheading">Waar gaat jouw tijd naartoe?</p>
                <h2 className="question-heading">Voeg een activiteit toe</h2>

                <div className="splitview">
                    <div className="split-left">
                        <div className="form-group">
                            <label htmlFor="customActivity">Vul in:</label>
                            <input
                                type="text"
                                onChange={this.handleChange}
                                className="form-control"
                                value={activity}
                                name="customActivity"
                                minLength={1}
                                maxLength={30}
                            />
                            <small className="form-text text-muted float-right">
                                {this.state.activity.length}
                                /30
                            </small>
                            <small className="form-text text-muted">
                                Bijvoorbeeld: gamen, de afwas doen, fietsen...
                            </small>
                        </div>
                    </div>
                    <div className="split-right">
                        {questions.map((q, index) => (
                            <div key={q.question} className={theme.question}>
                                <p>{q.question}</p>
                                <div className={theme.answerGroup}>
                                    {q.answers.map(a => (
                                        <button
                                            key={a}
                                            className={classnames(
                                                'btn',
                                                theme.answer,
                                                {
                                                    [theme.active]:
                                                        answers[index] === a,
                                                },
                                                {
                                                    [answerColors[a]]:
                                                        answerColors[a],
                                                }
                                            )}
                                            onClick={() => {
                                                this.handleQuestionAnswer(
                                                    index,
                                                    a
                                                ); // eslint-disable-line
                                            }}
                                        >
                                            {a}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default themr('ActivityPicker', baseActivityPickerTheme)(ActivityPicker);



// WEBPACK FOOTER //
// ./src/components/questions/ActivityPicker.js